/**
 * @graph-stack styling-pattern-watch
 * @graph-domain Styling
 * @graph-business React 18 の createRoot エントリポイント
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { getApiBaseUrl } from './config.js';
import './styles.css';

/** @graph-connects none */
const apiBaseUrl = getApiBaseUrl();

/** @graph-connects none */
const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App baseUrl={apiBaseUrl} />
    </StrictMode>,
  );
}
